import { Member, MemberLight } from "src/app/backend/models/member/member";
import { WarehouseStorageLight } from "src/app/backend/models/warehouse/warehouse-storage";

export interface AppState {
  tenantId: string | undefined;
  member: Member | undefined;

  members: MemberLight[];

  storages: WarehouseStorageLight[];

  /* debug */
  cache: Map<string, any> | undefined;
}

export const appState: AppState = {
  tenantId: undefined,
  member: undefined,
  members: [],
  storages: [],

  /* debug */
  cache: undefined
};

(<any>window)["appState"] = appState;
